import { OutlinedInput, InputAdornment, IconButton, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { Key } from 'ts-key-enum';
import { useHotKeyFocus } from '@tymely/utils';

export const SearchAddIntent = (props: {
    disabled: boolean;
    search: string;
    onAdd: () => void;
    onSearch: (value: string) => void;
}) => {
    const theme = useTheme();
    const searchRef = useHotKeyFocus([Key.Control, Key.Alt, 'KeyI']);
    return (
        <OutlinedInput
            size="small"
            value={props.search}
            onChange={(e) => props.onSearch(e.currentTarget.value)}
            disabled={props.disabled}
            placeholder="Search intent..."
            inputRef={searchRef}
            fullWidth
            sx={{ borderRadius: '5px', fontSize: theme.typography.body2.fontSize }}
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>
            }
            endAdornment={
                props.search && (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={() => props.onSearch('')} disabled={props.disabled}>
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                )
            }
        />
    );
};
